import * as zExt from "@redotech/rpc/ext";
import { shopperAgentStrategyIdFormat } from "@redotech/shopper-agent-strategy-id";
import * as z from "zod";

export const updateShopperAgentStrategy = {
  name: "updateShopperAgentStrategy" as const,
  input: z.object({
    strategyId: shopperAgentStrategyIdFormat.schema,
    goalGuidance: z.string(),
    outreachGuidance: z.string(),
    mongoDiscountId: zExt.objectId().nullable(),
  }),
  output: z.object({ success: z.boolean() }),
};
